import React, { useEffect, useMemo, useState } from "react";
import DoughnutChart from "./DoughnutChart";
import HorizontalBar from "./HorizontalBar";
import Header from "../../components/Header";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Link, useNavigate } from "react-router-dom";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Card } from "primereact/card";
import { Tag } from "primereact/tag";
import { DataStore, Predicates, SortDirection } from "aws-amplify";
import { HandbookAssignee, Handbook, Employee } from "../../models";
import { Handbook_Status, severity } from "../../helper/enum";
import moment from "moment";
import { Sidebar } from "primereact/sidebar";
import EditHandbookAssigneePopup from "./editpopup";
import { FilterMatchMode } from "primereact/api";

const emplyeeNameTemplate = record => {
  return (
    <div className="flex flex-wrap items-center gap-2 ">
      {/* <Avatar image="https://www.gravatar.com/avatar/205e460b479e2e5b48aec07710c08d50" size="small" shape="circle" /> */}
      {record?.employeeDetails?.employee_name}
    </div>
  );
};
const statusTemplate = record => {

  return <Tag value={record.status} severity={severity[record.status]}></Tag>;
};
const dateTemplate = (record, option) => {
  if (!record[option.field]) return "";
  return moment(record[option.field]).format("MM/DD/YYYY");
};
const EmployeeHandBook = () => {
  const navigate = useNavigate();
  const [visibleRight, setVisibleRight] = useState(false);
  const [selectedHandbook, setSelectedHandbook] = useState({});
  const [handbookAssignees, setHandbookAssignees] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [chartData, setChartData] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState({ name: "All", code: "all" });
  const statuses = [
    { name: "All", code: "all" },
    // { name: "New", code: "NEW" },
    { name: "Pending", code: Handbook_Status.PENDING },
    { name: "Acknowledge", code: Handbook_Status.ACKNOWLEDGE },
    { name: "Escalated", code: Handbook_Status.ESCALATED },
    { name: "Cancelled", code: Handbook_Status.CANCELLED },
    { name: "Resent", code: Handbook_Status.RESENT }
  ];
  const getChartData = async () => {
    const [employees, assignee] = await Promise.all([DataStore.query(Employee), DataStore.query(HandbookAssignee)]);

    const chartData = [
      { name: "Total Handbooks", value: assignee.length },
      { name: "Employees Acknowledgement", value: 0 },
      { name: "Pending Acknowledgement prior Submission Date", value: 0 },
      { name: "Pending Acknowledgement post Submission Date", value: 0 }
    ];


    for (const emp of assignee) {
      if (!!emp.acknowledge_date) {
        chartData[1].value++;
        if (new Date(emp.acknowledge_date) > new Date(emp.due_date)) {
          chartData[3].value++;
        }
      } else if (new Date(emp.due_date) < new Date()) {
        chartData[2].value++;
      }
    }
    setChartData(chartData);
  };

  useEffect(() => {
    getChartData();
  }, []);


  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState('');

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };
    _filters['global'].value = value;
    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const fetchHandbookEmployees = async () => {
    try {
      const res = await DataStore.query(HandbookAssignee, Predicates.ALL, {
        sort: s => s.createdAt(SortDirection.DESCENDING)
      });
      const handbookAssignees = [];
      for (let assignee of res) {
        const handbookAssignee = {
          ...assignee
        };
        const handbook = await DataStore.query(Handbook, assignee.handbook_id);
        handbookAssignee.handbookDetails = handbook;
        const employee = await DataStore.query(Employee, assignee.emp_id);
        handbookAssignee.employeeDetails = employee;

        handbookAssignees.push(handbookAssignee);
      }
      console.log(handbookAssignees);
      setHandbookAssignees(handbookAssignees);
    } catch (error) {
      console.log(error);
    }
  };


  const handbookAssigneesMemoised = useMemo(() => {
    return handbookAssignees
      .filter(
        assignee => assignee?.employeeDetails?.employee_name?.toLowerCase()?.includes(searchValue) || searchValue === ""
      )
      .filter(assignee => assignee.status === selectedStatus?.code || selectedStatus?.code === "all");
  }, [selectedStatus, handbookAssignees, searchValue]);

  useEffect(() => {
    const subscription = DataStore.observe(HandbookAssignee).subscribe(msg => {
      console.log(msg.model, msg.opType, msg.element);
      fetchHandbookEmployees();
    });
    fetchHandbookEmployees();
    return () => subscription.unsubscribe();
  }, []);
  return (
    <>
      <Header />

      <Sidebar
        visible={visibleRight}
        position="right"
        onHide={() => {
          setSelectedHandbook({});
          setVisibleRight(false);
          // debugger;
          fetchHandbookEmployees();
        }}
        style={{ width: "35vw" }}
        className="customesidebar1"
      >
        {selectedHandbook && (
          <EditHandbookAssigneePopup assigneeDetails={selectedHandbook} popupstate={() => setVisibleRight(false)} />
        )}
      </Sidebar>
      <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
        <div className="py-5 lg:flex lg:items-center lg:justify-end">
          {/* <div className="flex-1 min-w-0">
            <h6 className="flex items-center font-bold leading-7 text-gray-900 text-1xl sm:truncate sm:tracking-tight">
              <ArrowLongLeftIcon className="w-6 h-6 cursor-pointer me-1" aria-hidden="true" onClick={navigateToHome} />{" "}
              Return to Home
            </h6>
          </div> */}
          <div className="flex mt-5 lg:ml-4 lg:mt-0">
            <span className="sm:ml-3">
              {/* <button
            type="button"
            className="inline-flex items-center px-3 py-2 text-sm font-semibold text-white rounded-md shadow-sm bg-sky-700 hover:bg-sky-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Initiate Handbook
          </button> */}
              <div className="flex gap-2 xl:gap-[0.990vw] items-center">
                <Link
                  to="/new-handbook"
                  className="inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-sm bg-[#113699] hover:bg-[#0f296e] text-white"
                >
                  Create Handbook
                </Link>
                <Link
                  to="/assign-handbook"
                  className="inline-flex items-center px-3 py-2 text-sm font-semibold rounded-md shadow-sm text-[#344054] bg-white hover:bg-[#f5f5f5] border border-[#D0D5DD]"
                >
                  Assign Handbook
                </Link>

                {/* <Link to='#' className="w-full text-center tableBtn blue radius8" onClick={() => initiateNewReport()}>
                                                <i className="gusd-pluse-circle mx-1.5 "></i> Initiate New Report</Link> */}
              </div>
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-2 gap-2 hanbookChartHeight">
         
          <div className="w-full do_ch relative">
            {chartData.length > 0 && <DoughnutChart onRefresh={getChartData} data={[...chartData]} />}
          </div>
          <div className="w-full do_ch">
            <HorizontalBar data={chartData} />
          </div>
        </div>
        <div className="py-4 mt-3">
          <Card className="table_call">
            <div className="flex items-center justify-between px-4 pb-3 ">
              <div>
                <h6 className="font-bold text-gray-900 text-1xl">Employees</h6>
              </div>
              <div className="flex justify-end w-full gap-3 mb-2">
                <span className="p-input-icon-left">
                  <i className="pi pi-search" />
                  <InputText
                    value={globalFilterValue}
                    onChange={onGlobalFilterChange}
                    className="h-10"
                    placeholder="Search"
                    style={{ width: "320px" }}
                  />
                </span>

                <Dropdown
                  value={selectedStatus}
                  onChange={e => setSelectedStatus(e.value)}
                  options={statuses}
                  optionLabel="name"
                  placeholder="Status"
                  className="h-10"
                  style={{ width: "250px" }}
                />
              </div>
            </div>


            <DataTable
              rows={5}
              className="custpaginator custIcons custmBtnTable custTable"
              scrollable
              globalFilterFields={['handbookDetails.handbook_name', 'employeeDetails.employee_code', 'employeeDetails.employee_name', 'status', 'created_date', 'due_date']} emptyMessage="No records found."
              dataKey="id" filters={filters} filterDisplay="row"
              rowsPerPageOptions={[5, 10, 25, 50]}
              paginator
              responsiveLayout="scroll"
              paginatorTemplate="PrevPageLink FirstPageLink PageLinks NextPageLink CurrentPageReport RowsPerPageDropdown"
              value={handbookAssigneesMemoised}
            >
              {/* <Column field="no" sortable header="S. No"></Column> */}
              <Column field="handbookDetails.handbook_name" sortable header="Handbook Name"></Column>
              <Column field="employeeDetails.employee_code" sortable header="Employee Id"></Column>
              <Column
                field="employeeDetails.employee_name"
                sortable
                header="Employee Name"
                body={emplyeeNameTemplate}
              ></Column>
              <Column field="created_date" body={dateTemplate} sortable header="Due Date"></Column>
              <Column field="due_date" body={dateTemplate} sortable header="Date Handbook Sent"></Column>
              <Column field="status" sortable header="Status" body={statusTemplate}></Column>
              <Column
                field="action"
                header="Action"
                body={(record) => {
                  return (
                    <div className="flex justify-center w-full gap-2">
                      {
                        <Link
                          to="#"
                          className="py-2 px-2.5"
                          onClick={() => {
                            setSelectedHandbook(record);
                            setVisibleRight(true);
                          }}
                        >
                          <i className="gusd-eye text-[18px] text-[#667085] font-meduim"></i>
                        </Link>
                      }
                    </div>
                  );
                }}
              ></Column>
            </DataTable>
          </Card>
        </div>
      </div>
    </>
  );
};

export default EmployeeHandBook;
